import { Button } from "@/components/ui/button";
import { createPath } from "@/service/routing/routing";
import { CheckIcon, IterationCcwIcon, PlayIcon } from "lucide-react";
import { SuperLink as Link } from "@/components/common/super-link";
import { VerticalCard } from "@/components/common/vertical-card/vertical-card";
import { cn } from "@/lib/utils";

export const ClinicalCaseCard = ({
  clinicalCase,
  isFinished = false,
}: {
  clinicalCase: ClinicalCasePreviewVM;
  isFinished?: boolean;
}) => {
  const { name, image, category, quizScore, isNew } = clinicalCase;
  const { questionCount, correctAnswerCount } = quizScore ?? {
    questionCount: 0,
    correctAnswerCount: 0,
  };
  const correct = correctAnswerCount || 0;
  const incorrect = questionCount - correct;

  const extras = isFinished ? (
    <div className="mt-8 flex w-full items-center gap-4">
      <div className="h-1 w-1/3 overflow-hidden rounded-full bg-[#F34627]">
        <div
          className="h-full rounded-l-full bg-teal-700"
          style={{ width: `${(correct / (correct + incorrect)) * 100}%` }}
        />
      </div>
      <p className="text-muted-foreground text-sm">
        Wynik: {correct}/{correct + incorrect} pkt.
      </p>
    </div>
  ) : null;

  const button = !isFinished ? (
    <Button asChild variant="secondary" className="mt-8 w-full">
      <Link
        href={createPath("clinical_case.show", {
          slug: clinicalCase.slug,
          categorySlug: category?.slug,
        })}
        className="z-10"
      >
        <div className="flex items-center justify-center gap-2">
          <PlayIcon className="h-4 w-4" />
          <span className="leading-none">Rozpocznij wizytę</span>
        </div>
      </Link>
    </Button>
  ) : null;

  const hoverIcon = isFinished ? <IterationCcwIcon /> : <PlayIcon />;
  const absoluteExtras = isFinished ? (
    <div className="absolute top-4 right-4 z-10">
      <div className="flex h-4 w-4 items-center justify-center rounded-xs bg-[#0d9488]">
        <CheckIcon className="h-4 w-4 text-white" />
      </div>
    </div>
  ) : null;

  return (
    <Link
      href={createPath("clinical_case.show", {
        slug: clinicalCase.slug,
        categorySlug: category?.slug,
      })}
      className="flex h-full flex-1 self-stretch [&:empty]:hidden"

      // legacyBehavior
    >
      <VerticalCard
        image={image}
        title={name}
        extras={
          <div className="relative z-10 flex flex-1 flex-col justify-between">
            <Link
              href={createPath("clinical_case.category", {
                categorySlug: category?.slug,
              })}
              className="text-remedium-blue z-10 hover:underline"
            >
              <p className="text-remedium-blue text-sm font-medium">
                {category?.name}
              </p>
            </Link>
            {extras}
          </div>
        }
        absoluteExtras={absoluteExtras}
        tag={isNew ? "Nowość" : undefined}
        button={button}
        hoverIcon={hoverIcon}
        className={cn(isFinished && "[&_img]:grayscale")}
      />
    </Link>
  );
};
